<template>
  <div class="dashboard-editor-container">
    <div class="clearfix">
      <pan-thumb :image="safeAvatar" class="avatar-thumb" :aria-label="`User avatar of ${name}`">
        Your roles:
        <template v-if="hasRoles">
          <span v-for="item in roles" :key="item" class="pan-info-roles">{{ item }}</span>
        </template>
        <template v-else>
          <span class="pan-info-roles roles-empty">No roles</span>
        </template>
      </pan-thumb>

      <div class="info-container">
        <span class="display_name">{{ name }}</span>
        <span class="page-subtitle" v-once>Editor's Dashboard</span>
      </div>
    </div>
    <div>
      <img
        :src="bannerSrc"
        class="emptyGif"
        alt="Welcome banner"
        loading="lazy"
        decoding="async"
        @error="onBannerError"
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PanThumb from '@/components/PanThumb'
// import GithubCorner from "@/components/GithubCorner";

export default {
  name: 'DashboardEditor',
  components: { PanThumb },
  data() {
    return {
      bannerSrc: 'https://wpimg.wallstcn.com/0e03b7da-db9e-4819-ba10-9016ddfdaed3',
      bannerErrored: false
    }
  },
  computed: {
    ...mapGetters(['name', 'avatar', 'roles']),
    hasRoles() {
      return Array.isArray(this.roles) && this.roles.length > 0
    },
    safeAvatar() {
      // fallback avatar if missing
      return this.avatar || require('@/assets/02.png')
    }
  },
  methods: {
    onBannerError() {
      if (!this.bannerErrored) {
        this.bannerErrored = true
        this.bannerSrc = require('@/assets/404_images/404.png')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.emptyGif {
  display: block;
  width: 45%;
  margin: 0 auto;
}

.dashboard-editor-container {
  background-color: #e3e3e3;
  min-height: 100vh;
  padding: 50px 60px 0px;
  .pan-info-roles {
    font-size: 12px;
    font-weight: 700;
    color: #333;
    display: block;
  }
  .roles-empty {
    color: #909399;
    font-weight: 400;
  }
  .info-container {
    position: relative;
    margin-left: 190px;
    height: 150px;
    line-height: 200px;
    .display_name {
      font-size: 48px;
      line-height: 48px;
      color: #212121;
      position: absolute;
      top: 25px;
    }
    .page-subtitle {
      font-size: 20px;
      padding-top: 20px;
      display: inline-block;
    }
  }
}
.avatar-thumb {
  float: left;
}
</style>
